import { TContrastLevel } from '~theme/typings'
import { TSingleSpace } from '~ui/styleGuide/spaces'

/**
 * space (padding) that the labels or messages in the form should have from the left side of the input
 */
export const FORM_LABEL_SPACE_LEFT: TSingleSpace = `small`
/**
 * contrast level of a divider inside a group of inputs (checkboxes, radios, ...)
 */
export const INPUT_GROUP_DIVIDER_CONTRAST: TContrastLevel = `normal`
